"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Error = /** @class */ (function () {
    function Error() {
    }
    return Error;
}());
exports.Error = Error;
var ErrorDetails = /** @class */ (function () {
    function ErrorDetails() {
    }
    return ErrorDetails;
}());
exports.ErrorDetails = ErrorDetails;
var EnumBase = /** @class */ (function () {
    function EnumBase(name, id) {
        this.name = name;
        this.id = id;
    }
    return EnumBase;
}());
exports.EnumBase = EnumBase;
/* Response  */
var Template = /** @class */ (function () {
    function Template() {
    }
    return Template;
}());
exports.Template = Template;
var TemplateFile = /** @class */ (function () {
    function TemplateFile() {
    }
    return TemplateFile;
}());
exports.TemplateFile = TemplateFile;
var TemplateDocumentFile = /** @class */ (function (_super) {
    __extends(TemplateDocumentFile, _super);
    function TemplateDocumentFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TemplateDocumentFile;
}(TemplateFile));
exports.TemplateDocumentFile = TemplateDocumentFile;
var TemplateImageFile = /** @class */ (function (_super) {
    __extends(TemplateImageFile, _super);
    function TemplateImageFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TemplateImageFile;
}(TemplateFile));
exports.TemplateImageFile = TemplateImageFile;
var TemplateVideoFile = /** @class */ (function (_super) {
    __extends(TemplateVideoFile, _super);
    function TemplateVideoFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TemplateVideoFile;
}(TemplateFile));
exports.TemplateVideoFile = TemplateVideoFile;
var AssetFile = /** @class */ (function () {
    function AssetFile() {
    }
    return AssetFile;
}());
exports.AssetFile = AssetFile;
var VersionsGroup = /** @class */ (function () {
    function VersionsGroup() {
    }
    return VersionsGroup;
}());
exports.VersionsGroup = VersionsGroup;
var FeedDetails = /** @class */ (function () {
    function FeedDetails() {
    }
    return FeedDetails;
}());
exports.FeedDetails = FeedDetails;
var AssetSet = /** @class */ (function () {
    function AssetSet() {
    }
    return AssetSet;
}());
exports.AssetSet = AssetSet;
var AssetDocumentFile = /** @class */ (function (_super) {
    __extends(AssetDocumentFile, _super);
    function AssetDocumentFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AssetDocumentFile;
}(AssetFile));
exports.AssetDocumentFile = AssetDocumentFile;
var AssetImageFile = /** @class */ (function (_super) {
    __extends(AssetImageFile, _super);
    function AssetImageFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AssetImageFile;
}(AssetFile));
exports.AssetImageFile = AssetImageFile;
var AssetVideoFile = /** @class */ (function (_super) {
    __extends(AssetVideoFile, _super);
    function AssetVideoFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AssetVideoFile;
}(AssetFile));
exports.AssetVideoFile = AssetVideoFile;
var Owner = /** @class */ (function () {
    function Owner() {
    }
    return Owner;
}());
exports.Owner = Owner;
var AssetFileRender = /** @class */ (function () {
    function AssetFileRender() {
    }
    return AssetFileRender;
}());
exports.AssetFileRender = AssetFileRender;
/* Common  */
var AssetAccessLevel = /** @class */ (function (_super) {
    __extends(AssetAccessLevel, _super);
    function AssetAccessLevel(name, id) {
        return _super.call(this, name, id) || this;
    }
    AssetAccessLevel.GetAll = function () {
        var all = [AssetAccessLevel.Private, AssetAccessLevel.Public];
        return all;
    };
    AssetAccessLevel.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AssetAccessLevel.Private = new AssetAccessLevel("Private", "Private");
    AssetAccessLevel.Public = new AssetAccessLevel("Public", "Public");
    AssetAccessLevel.Unknown = new AssetAccessLevel("Unknown Access Level", "Unknown");
    return AssetAccessLevel;
}(EnumBase));
exports.AssetAccessLevel = AssetAccessLevel;
var AssetStatus = /** @class */ (function (_super) {
    __extends(AssetStatus, _super);
    function AssetStatus(name, id) {
        return _super.call(this, name, id) || this;
    }
    AssetStatus.GetAll = function () {
        var all = [AssetStatus.WaitingUpload, AssetStatus.Ready, AssetStatus.Disabled];
        return all;
    };
    AssetStatus.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AssetStatus.WaitingUpload = new AssetStatus("Waiting for Upload", "Waiting");
    AssetStatus.Ready = new AssetStatus("Ready", "Ready");
    AssetStatus.Disabled = new AssetStatus("Disabled", "Disabled");
    AssetStatus.Unknown = new AssetStatus("Unknown Status", "Unknown");
    return AssetStatus;
}(EnumBase));
exports.AssetStatus = AssetStatus;
var AssetType = /** @class */ (function (_super) {
    __extends(AssetType, _super);
    function AssetType(name, id) {
        return _super.call(this, name, id) || this;
    }
    AssetType.GetAll = function () {
        var all = [this.Image, this.Video, this.Document];
        return all;
    };
    AssetType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    AssetType.Image = new AssetType("Image", "Image");
    AssetType.Video = new AssetType("Video", "Video");
    AssetType.Document = new AssetType("Document", "Document");
    AssetType.Unknown = new AssetType("Unknown Type", "Unknown");
    return AssetType;
}(EnumBase));
exports.AssetType = AssetType;
var FileType = /** @class */ (function (_super) {
    __extends(FileType, _super);
    function FileType(name, id) {
        return _super.call(this, name, id) || this;
    }
    FileType.GetAll = function () {
        return [this.File, this.Link];
    };
    FileType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    FileType.File = new FileType("File", "File");
    FileType.Link = new FileType("Link", "Link");
    return FileType;
}(EnumBase));
exports.FileType = FileType;
var DocumentFileFormat = /** @class */ (function (_super) {
    __extends(DocumentFileFormat, _super);
    function DocumentFileFormat(name, id) {
        return _super.call(this, name, id) || this;
    }
    DocumentFileFormat.GetAll = function () {
        var all = [this.PDF, this.DOC, this.DOCX, this.XML, this.XLS, this.XLSX, this.PPT, this.PPS, this.PPSX, this.PPTX, this.GOOGLEDOC, this.UNKNOWN];
        return all;
    };
    DocumentFileFormat.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    DocumentFileFormat.PDF = new DocumentFileFormat("PDF", "PDF");
    DocumentFileFormat.DOC = new DocumentFileFormat("DOC", "DOC");
    DocumentFileFormat.DOCX = new DocumentFileFormat("DOCX", "DOCX");
    DocumentFileFormat.XML = new DocumentFileFormat("XML", "XML");
    DocumentFileFormat.XLS = new DocumentFileFormat("XLS", "XLS");
    DocumentFileFormat.XLSX = new DocumentFileFormat("XLSX", "XLSX");
    DocumentFileFormat.PPT = new DocumentFileFormat("PPT", "PPT");
    DocumentFileFormat.PPS = new DocumentFileFormat("PPS", "PPS");
    DocumentFileFormat.PPSX = new DocumentFileFormat("PPSX", "PPSX");
    DocumentFileFormat.PPTX = new DocumentFileFormat("PPTX", "PPTX");
    DocumentFileFormat.GOOGLEDOC = new DocumentFileFormat("GOOGLEDOC", "GOOGLEDOC");
    DocumentFileFormat.UNKNOWN = new DocumentFileFormat("Unknown Document Format", "Unknown");
    return DocumentFileFormat;
}(EnumBase));
exports.DocumentFileFormat = DocumentFileFormat;
var ImageFileFormat = /** @class */ (function (_super) {
    __extends(ImageFileFormat, _super);
    function ImageFileFormat(name, id) {
        return _super.call(this, name, id) || this;
    }
    ImageFileFormat.GetAll = function () {
        var all = [this.JPEG, this.PNG, this.GIF, this.SVG, this.TIFF, this.PSD, this.AI, this.EPS, this.UNKNOWN];
        return all;
    };
    ImageFileFormat.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ImageFileFormat.JPEG = new ImageFileFormat("JPEG", "JPEG");
    ImageFileFormat.PNG = new ImageFileFormat("PNG", "PNG");
    ImageFileFormat.GIF = new ImageFileFormat("GIF", "GIF");
    ImageFileFormat.SVG = new ImageFileFormat("SVG", "SVG");
    ImageFileFormat.TIFF = new ImageFileFormat("TIFF", "TIFF");
    ImageFileFormat.PSD = new ImageFileFormat("PSD", "PSD");
    ImageFileFormat.AI = new ImageFileFormat("AI", "AI");
    ImageFileFormat.EPS = new ImageFileFormat("EPS", "EPS");
    ImageFileFormat.UNKNOWN = new ImageFileFormat("Unknown Image Format", "Unknown");
    return ImageFileFormat;
}(EnumBase));
exports.ImageFileFormat = ImageFileFormat;
var VideoFileFormat = /** @class */ (function (_super) {
    __extends(VideoFileFormat, _super);
    function VideoFileFormat(name, id) {
        return _super.call(this, name, id) || this;
    }
    VideoFileFormat.GetAll = function () {
        var all = [this.AVI, this.FLV, this.MP4, this.MOV, this.MKV, this.MTS, this.MP3, this.WAV, this.UNKNOWN];
        return all;
    };
    VideoFileFormat.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    VideoFileFormat.AVI = new VideoFileFormat("AVI", "AVI");
    VideoFileFormat.FLV = new VideoFileFormat("FLV", "FLV");
    VideoFileFormat.MP4 = new VideoFileFormat("MP4", "MP4");
    VideoFileFormat.MOV = new VideoFileFormat("MOV", "MOV");
    VideoFileFormat.MKV = new VideoFileFormat("Makroska", "MKV");
    VideoFileFormat.MTS = new VideoFileFormat("MTS", "MTS");
    VideoFileFormat.MP3 = new VideoFileFormat("MP3", "MP3");
    VideoFileFormat.WAV = new VideoFileFormat("WAV", "WAV");
    VideoFileFormat.UNKNOWN = new VideoFileFormat("Unknown Video Format", "Unknown");
    return VideoFileFormat;
}(EnumBase));
exports.VideoFileFormat = VideoFileFormat;
var ThumbnailGenerationMode = /** @class */ (function (_super) {
    __extends(ThumbnailGenerationMode, _super);
    function ThumbnailGenerationMode(name, id) {
        return _super.call(this, name, id) || this;
    }
    ThumbnailGenerationMode.GetAll = function () {
        var all = [this.PAD, this.SQUARECROP, this.SMARTCROP, this.UNKNOWN];
        return all;
    };
    ThumbnailGenerationMode.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    ThumbnailGenerationMode.PAD = new ThumbnailGenerationMode("Pad", "pad");
    ThumbnailGenerationMode.SQUARECROP = new ThumbnailGenerationMode("Square Crop", "squarecrop");
    ThumbnailGenerationMode.SMARTCROP = new ThumbnailGenerationMode("Smart Crop", "smartcrop");
    ThumbnailGenerationMode.UNKNOWN = new ThumbnailGenerationMode("Unknown Thumbnail Generation Mode", "Unknown");
    return ThumbnailGenerationMode;
}(EnumBase));
exports.ThumbnailGenerationMode = ThumbnailGenerationMode;
var BusinessUnit = /** @class */ (function (_super) {
    __extends(BusinessUnit, _super);
    function BusinessUnit(name, id) {
        return _super.call(this, name, id) || this;
    }
    BusinessUnit.GetAll = function () {
        var all = [BusinessUnit.Brafton, BusinessUnit.ContentLead, BusinessUnit.Castleford, BusinessUnit.UK];
        return all;
    };
    BusinessUnit.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    BusinessUnit.Brafton = new BusinessUnit("Brafton", 2);
    BusinessUnit.ContentLead = new BusinessUnit("ContentLead", 1);
    BusinessUnit.Castleford = new BusinessUnit("Castleford", 7);
    BusinessUnit.UK = new BusinessUnit("UK", 8);
    BusinessUnit.Unknown = new BusinessUnit("Unknown Business Unit", -1);
    return BusinessUnit;
}(EnumBase));
exports.BusinessUnit = BusinessUnit;
var OwnerType = /** @class */ (function (_super) {
    __extends(OwnerType, _super);
    function OwnerType(name, id) {
        return _super.call(this, name, id) || this;
    }
    OwnerType.GetAll = function () {
        var all = [OwnerType.Person, OwnerType.Team];
        return all;
    };
    OwnerType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    OwnerType.Person = new OwnerType("Person", "Person");
    OwnerType.Team = new OwnerType("Team", "Team");
    OwnerType.Unknown = new OwnerType("Unknown Owner Type", "UnknownOwnerType");
    return OwnerType;
}(EnumBase));
exports.OwnerType = OwnerType;
var RenderType = /** @class */ (function (_super) {
    __extends(RenderType, _super);
    function RenderType(name, id) {
        return _super.call(this, name, id) || this;
    }
    RenderType.GetAll = function () {
        var all = [RenderType.Hosted, RenderType.AssetsRaw, RenderType.AssetsFriendly, RenderType.NonCached];
        return all;
    };
    RenderType.FromId = function (pid) {
        var result = this.GetAll().find(function (x) { return x.id == pid; });
        return result;
    };
    RenderType.Hosted = new RenderType("Hosted Friendly", "Hosted");
    RenderType.AssetsRaw = new RenderType("Assets Raw", "AssetsRaw");
    RenderType.AssetsFriendly = new RenderType("Assets Friendly", "AssetsFriendly");
    RenderType.NonCached = new RenderType("Non-Cached Raw", "NonCached");
    RenderType.UnKnown = new RenderType("Unknown Render Type", "UnknownRenderType");
    return RenderType;
}(EnumBase));
exports.RenderType = RenderType;
/* Request */
var AmendAssetSetRequest = /** @class */ (function () {
    function AmendAssetSetRequest() {
    }
    return AmendAssetSetRequest;
}());
exports.AmendAssetSetRequest = AmendAssetSetRequest;
var CreateTemplateRequest = /** @class */ (function () {
    function CreateTemplateRequest() {
    }
    return CreateTemplateRequest;
}());
exports.CreateTemplateRequest = CreateTemplateRequest;
var CreateAssetLinkRequest = /** @class */ (function () {
    function CreateAssetLinkRequest() {
    }
    return CreateAssetLinkRequest;
}());
exports.CreateAssetLinkRequest = CreateAssetLinkRequest;
var CreateAssetSetRequest = /** @class */ (function () {
    function CreateAssetSetRequest() {
    }
    return CreateAssetSetRequest;
}());
exports.CreateAssetSetRequest = CreateAssetSetRequest;
var CreateAssetSetFromDeliverableRequest = /** @class */ (function () {
    function CreateAssetSetFromDeliverableRequest() {
    }
    return CreateAssetSetFromDeliverableRequest;
}());
exports.CreateAssetSetFromDeliverableRequest = CreateAssetSetFromDeliverableRequest;
var CreateAssetSetFromDeliverablePhaseRequest = /** @class */ (function () {
    function CreateAssetSetFromDeliverablePhaseRequest() {
    }
    return CreateAssetSetFromDeliverablePhaseRequest;
}());
exports.CreateAssetSetFromDeliverablePhaseRequest = CreateAssetSetFromDeliverablePhaseRequest;
var AddDocumentFileRequest = /** @class */ (function () {
    function AddDocumentFileRequest() {
    }
    return AddDocumentFileRequest;
}());
exports.AddDocumentFileRequest = AddDocumentFileRequest;
var AddImageFileRequest = /** @class */ (function () {
    function AddImageFileRequest() {
    }
    return AddImageFileRequest;
}());
exports.AddImageFileRequest = AddImageFileRequest;
var AddVideoFileRequest = /** @class */ (function () {
    function AddVideoFileRequest() {
    }
    return AddVideoFileRequest;
}());
exports.AddVideoFileRequest = AddVideoFileRequest;
var AmendDocumentFileRequest = /** @class */ (function () {
    function AmendDocumentFileRequest() {
    }
    return AmendDocumentFileRequest;
}());
exports.AmendDocumentFileRequest = AmendDocumentFileRequest;
var AmendImageFileRequest = /** @class */ (function () {
    function AmendImageFileRequest() {
    }
    return AmendImageFileRequest;
}());
exports.AmendImageFileRequest = AmendImageFileRequest;
var AmendVideoFileRequest = /** @class */ (function () {
    function AmendVideoFileRequest() {
    }
    return AmendVideoFileRequest;
}());
exports.AmendVideoFileRequest = AmendVideoFileRequest;
var RemoveFileRequest = /** @class */ (function () {
    function RemoveFileRequest() {
    }
    return RemoveFileRequest;
}());
exports.RemoveFileRequest = RemoveFileRequest;
var AddTemplateDocumentFileRequest = /** @class */ (function () {
    function AddTemplateDocumentFileRequest() {
    }
    return AddTemplateDocumentFileRequest;
}());
exports.AddTemplateDocumentFileRequest = AddTemplateDocumentFileRequest;
var AddTemplateImageFileRequest = /** @class */ (function () {
    function AddTemplateImageFileRequest() {
    }
    return AddTemplateImageFileRequest;
}());
exports.AddTemplateImageFileRequest = AddTemplateImageFileRequest;
var AddTemplateVideoFileRequest = /** @class */ (function () {
    function AddTemplateVideoFileRequest() {
    }
    return AddTemplateVideoFileRequest;
}());
exports.AddTemplateVideoFileRequest = AddTemplateVideoFileRequest;
var AmendTemplateDocumentFileRequest = /** @class */ (function () {
    function AmendTemplateDocumentFileRequest() {
    }
    return AmendTemplateDocumentFileRequest;
}());
exports.AmendTemplateDocumentFileRequest = AmendTemplateDocumentFileRequest;
var AmendTemplateImageFileRequest = /** @class */ (function () {
    function AmendTemplateImageFileRequest() {
    }
    return AmendTemplateImageFileRequest;
}());
exports.AmendTemplateImageFileRequest = AmendTemplateImageFileRequest;
var AmendTemplateVideoFileRequest = /** @class */ (function () {
    function AmendTemplateVideoFileRequest() {
    }
    return AmendTemplateVideoFileRequest;
}());
exports.AmendTemplateVideoFileRequest = AmendTemplateVideoFileRequest;
var RemoveTemplateFileRequest = /** @class */ (function () {
    function RemoveTemplateFileRequest() {
    }
    return RemoveTemplateFileRequest;
}());
exports.RemoveTemplateFileRequest = RemoveTemplateFileRequest;
var AWSUrl = /** @class */ (function () {
    function AWSUrl() {
    }
    return AWSUrl;
}());
exports.AWSUrl = AWSUrl;
var FilesGroup = /** @class */ (function () {
    function FilesGroup() {
    }
    return FilesGroup;
}());
exports.FilesGroup = FilesGroup;
var UploadResponse = /** @class */ (function () {
    function UploadResponse() {
    }
    return UploadResponse;
}());
exports.UploadResponse = UploadResponse;
